import { identity } from 'underscore';
import { convertToAdModelInResponse } from '@bingads-webui-campaign-react/responsive-ad-editor-utils';

const convertFuncs = {
  Responsive: convertToAdModelInResponse,
  ResponsiveSearch: identity,
};

export const viewModelToModelInResponseForAd = (adViewModel = { data: {} }, adType) => {
  const { data } = adViewModel;
  const convertFunc = convertFuncs[adType] || identity;
  return {
    ...adViewModel,
    data: convertFunc(data),
  };
};
